import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'
import { useSubscription } from '@apollo/client'

import styles from './style.module.scss'
import navStyles from '@shared/components/commonNav/style.module.scss'

import dynamic from 'next/dynamic'
import { tableLoader } from '@shared/libs/allLoader'
import { FULL_SCOREBOARD } from '@graphql/match/match.subscription'
import { getMatchPlayers } from '@shared/libs/match-detail'
//

const ScorecardTable = dynamic(() => import('@shared/components/match/scorecardTable'), { loading: () => tableLoader() })
const FallWickets = dynamic(() => import('@shared/components/match/fallWickets'))
const ThemeTable = dynamic(() => import('@shared/components/themeTable'))
const BowlerDataRow = dynamic(() => import('@shared/components/match/scorecardTable/BowlerDataRow'))
// const MatchDetailOverview = dynamic(() => import('@shared/components/match/matchDetailOverview'))

const MatchDetailScorecard = ({ data, style, squad, matchDetail, matchOverView, is100 }) => {
  const players = getMatchPlayers()

  const [fullScoreBoard, setFullScoreBoard] = useState(data?.fetchLiveInningsData)

  let labels
  if (is100) {
    labels = [
      `${'Bowler'}`,
      `${'B'}`,
      `${'M'}`,
      `${'R'}`,
      `${'W'}`,
      `${'NB'}`,
      `${'WD'}`,
      `${'Eco'}`
    ]
  } else {
    labels = [
      `${'Bowler'}`,
      `${'Ov'}`,
      `${'M'}`,
      `${'R'}`,
      `${'W'}`,
      `${'NB'}`,
      `${'WD'}`,
      `${'Eco'}`
    ]
  }

  const table = useRef({ sOvers: 'Ov', nMaidens: 'M', nRunsConceded: 'R', nWickets: 'W', nNoBalls: 'NB', nWides: 'WD', sEcon: 'Eco' })
  const fullSquad = squad?.listMatchSquad
  const [team, setTeam] = useState(fullScoreBoard?.length - 1)

  typeof window !== 'undefined' &&
    useSubscription(FULL_SCOREBOARD, {
      variables: { input: { iMatchId: matchDetail?._id, nInningNumber: matchDetail?.nLatestInningNumber } },
      onData: ({ data: subscriptionData }) => {
        const match = subscriptionData?.data?.fetchLiveInningsData
        if (match) {
          setFullScoreBoard(
            data?.fetchLiveInningsData?.map((item, index) => {
              if (item?.nInningNumber === match?.nInningNumber) {
                return match
              }
              return item
            })
          )
        }
      }
    })
  return (
    <>
      <section className={`${styles.scorecards}`}>
        <Nav
          className={`${navStyles.commonNav} ${navStyles.pillsNav} ${styles.nav} justify-content-start mb-2 mt-2 mt-sm-0 flex-nowrap text-nowrap overflow-auto`}
          variant="pills">
          {fullScoreBoard?.map((data, i) => {
            return (
              <Nav.Item key={i} className={`${navStyles.item}`}>
                <a className={`${team === i && navStyles.active} nav-link`} onClick={() => setTeam(i)}>
                  <div className="d-flex justify-content-between align-items-center flex-grow-1">{`${data?.sShortName} - ${(data?.oEquations?.nRuns ?? 0)}/${(data?.oEquations?.nWickets ?? 0)}`}</div>
                </a>
              </Nav.Item>
            )
          })}
        </Nav>
        {fullScoreBoard?.map((data, i) => {
          if (team === i) {
            return (
              <>
                <ScorecardTable currentTeam={team + 1} is100={is100} data={data} fullSquad={fullSquad} matchDetail={matchDetail}/>
                {data?.aBowlers?.length > 0 && (
                  <div className={`${styles.personTbl} content-visibility-auto`}>
                    <ThemeTable labels={labels} isBordered={true}>
                      {data?.aBowlers?.map((bowler, index) => {
                        return <BowlerDataRow key={index} currentTeam={team + 1} matchDetail={matchDetail} bowler={bowler} players={players} table={table?.current} />
                      })}
                    </ThemeTable>
                  </div>
                )}
                {data?.aFOWs?.length > 0 && <FallWickets is100={is100} data={data} styles={style} />}
              </>
            )
          } else {
            return null
          }
        })}
      </section>
      {/* {matchDetail?.sStatusStr !== 'scheduled' && matchDetail?.bIsCommentary &&
        <section>
          <MatchDetailOverview data={matchOverView} matchDetail={matchDetail} />
        </section>} */}
    </>
  )
}

MatchDetailScorecard.propTypes = {
  data: PropTypes.object,
  style: PropTypes.any,
  squad: PropTypes.object,
  matchDetail: PropTypes.object,
  matchOverView: PropTypes.object,
  is100: PropTypes.bool
}
export default MatchDetailScorecard
